import { all, fork } from 'redux-saga/effects';
import tutorSaga from './tutorSaga';
import brandingSaga from './brandingSaga';

// Root saga that combines all sagas
export default function* rootSaga() {
  yield all([
    fork(tutorSaga),
    fork(brandingSaga),
  ]);
}
